import { FC, useEffect } from 'react';
import { setGlobalSkipErrorValidation, setOnUnauthorizedError } from 'network-utils';

const NetworkErrorsContainer: FC = () => {
    useEffect(() => {
        const handleUnauthorizedError = () => {
            if (window.top && !window.location.href.endsWith('/app/login')) {
                sessionStorage.setItem('cbHistory', window.top.location.href);
                window.top.location.href = '/app/login';
                return true;
            }
            return false;
        };

        setGlobalSkipErrorValidation(true);
        setOnUnauthorizedError(handleUnauthorizedError);
    }, []);

    return <div></div>;
};

export default NetworkErrorsContainer;
